import { t } from 'i18next';
import { call, put, takeLatest } from 'redux-saga/effects';
import { calculateAllMetrics, calculateMetrics, calculateRackMetrics } from '../../lib';
import { getAllMetrics, getMetrics, getRackMetrics } from './data';
import { errorReceiveAllMetrics, errorReceiveMetrics, errorReceiveRackMetrics, failedReceiveAllMetrics, failedReceiveMetrics, failedReceiveRackMetrics, receiveAllMetrics, receiveMetrics, receiveRackMetrics } from './slice';
export function* requestAllMetrics() {
    try {
        const response = yield call(getAllMetrics);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveAllMetrics());
        }
        else if (data) {
            const sites = Object.keys(data);
            if (sites.length < 1) {
                throw new Error(t('NO_METRICS_AVAILABLE', {
                    ns: 'Common'
                }));
            }
            const calculatedAllMetrics = calculateAllMetrics(data);
            yield put(receiveAllMetrics(calculatedAllMetrics));
        }
        else {
            throw new Error(t('NO_METRICS_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveAllMetrics());
    }
}
export function* requestMetrics(action) {
    try {
        const { locationSlug } = action.payload;
        const response = yield call(getMetrics, locationSlug);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveMetrics());
        }
        else if (data) {
            if (data.length < 1) {
                throw new Error(t('NO_METRICS_AVAILABLE', {
                    ns: 'Common'
                }));
            }
            const calculatedMetrics = calculateMetrics(data);
            yield put(receiveMetrics(calculatedMetrics));
        }
        else {
            throw new Error(t('NO_METRICS_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveMetrics());
    }
}
export function* requestRackMetrics(action) {
    try {
        const { locationSlug, rackId } = action.payload;
        const response = yield call(getRackMetrics, locationSlug, rackId);
        const { data, error } = response;
        if (error) {
            yield put(errorReceiveRackMetrics());
        }
        else if (data) {
            if (data.length < 1) {
                throw new Error(t('NO_METRICS_AVAILABLE', {
                    ns: 'Common'
                }));
            }
            const calculatedRackMetrics = calculateRackMetrics(data);
            yield put(receiveRackMetrics(calculatedRackMetrics));
        }
        else {
            throw new Error(t('NO_METRICS_AVAILABLE', {
                ns: 'Common'
            }));
        }
    }
    catch (e) {
        yield put(failedReceiveRackMetrics());
    }
}
export function* watchRequestAllMetrics() {
    yield takeLatest('metrics/requestAllMetrics', requestAllMetrics);
}
export function* watchRequestMetrics() {
    yield takeLatest('metrics/requestMetrics', requestMetrics);
}
export function* watchRequestRackMetrics() {
    yield takeLatest('metrics/requestRackMetrics', requestRackMetrics);
}
